module.exports = __webpack_public_path__ + "static/img/ABB.e254d0eb.png";